
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from "../../../components/common/Sidebar";
import { BackIcon, NextIcon, PasswordIcon, ShowPasswordIcon } from "../../../components/common/IconComponents";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikControl from '../../../components/signUpForm/ReusableFormik/FormikControl';

const ChangePassword = () => {
    const userRole = 'admin'; 
    let listItems;

    if (userRole === 'admin') {
        listItems = [
            { label: 'Company Profile' },
            { label: 'My Profile' },
            { label: 'Password' },
            { label: 'Notification' },
            { label: 'Maintain Roles' },
        ];
    } else if (userRole === 'analyst') {
        listItems = [
            { label: 'My Profile' },
            { label: 'Password' },
            { label: 'Notification' },
        ];
    }

    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);
    const [passwordIcon, setPasswordIcon] = useState(<PasswordIcon />);

    const toggleShowPassword = () => {
        setShowPassword(!showPassword);
        setPasswordIcon(showPassword ? <PasswordIcon /> : <ShowPasswordIcon className="w-4" />);
    };

    const initialValues = {
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    };

    const validationSchema = Yup.object({
        currentPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                'Password must contain at least one digit, one lowercase letter, one uppercase letter, and one special character'
            ),
        newPassword: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters long')
            .matches(
                /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                'Password must contain at least one digit, one lowercase letter, one uppercase letter, and one special character'
            ),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref('newPassword'), ''], 'Passwords must match')
            .required('Required'),
    });

    // Form submission
    const onSubmit = (values) => {
        console.log('Form data', values);
        navigate("/resetNotification");
    };

    const goBack = () => {
        window.history.back();
    };

    return (
        <div className="relative flex flex-col md:flex-row px-3">
            <Sidebar />

            <div className="md:w-2/5 md:ps-2 md:border-r-2 border-th-bg">
                <nav className="w-full md:w-[451px] fixed z-20 top-0 bg-white">
                    <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Settings</h1>
                </nav>

                <div className="mt-4 md:mt-24 mb-4">
                    <ul>
                        {listItems.map((item, index) => (
                            <li
                                key={index}
                                className={`flex items-center justify-between cursor-pointer text-xs md:text-base font-normal mb-4 p-2 md:p-3 rounded ${index === 2
                                    ? 'bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none'
                                    : 'bg-white text-disabled'
                                    }`}
                            >
                                {item.label}
                                {index === 2 && <NextIcon className="ml-2" />}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="w-auto md:w-3/5 md:px-4">
                <div className="px-2">
                    <nav className="flex items-center gap-4 md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
                        <BackIcon className="mt-4 py-2" onClick={goBack} />
                        <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Change password</h1>
                    </nav>

                    <div className="mt-4 md:mt-24 mb-4">
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                            {(formik) => {
                                return (
                                    <Form className="">
                                        <div className="relative">
                                            <FormikControl
                                                control="input"
                                                label="Current Password"
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="********"
                                                name="currentPassword"
                                            />
                                            <span
                                                onClick={toggleShowPassword}
                                                className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
                                            >
                                                {passwordIcon}
                                            </span>
                                        </div>

                                        <div className="relative">
                                            <FormikControl
                                                control="input"
                                                label="Create new password"
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="********"
                                                name="newPassword"
                                            />
                                            <span
                                                onClick={toggleShowPassword}
                                                className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
                                            >
                                                {passwordIcon}
                                            </span>
                                        </div>

                                        <div className="relative">
                                            <FormikControl
                                                control="input"
                                                label="Re-enter password"
                                                type={showPassword ? 'text' : 'password'}
                                                placeholder="********"
                                                name="confirmPassword"
                                            />
                                            <span
                                                onClick={toggleShowPassword}
                                                className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
                                            >
                                                {passwordIcon}
                                            </span>
                                        </div>

                                        <button
                                            type="submit"
                                            className="bg-indigo-500 text-slate-50 border rounded cursor-pointer my-7 py-1 px-16"
                                            disabled={!formik.isValid}
                                        >
                                            Save
                                        </button>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChangePassword;




// DYNAMIC LIST VIEW BASED ON USER ROLE LIST VIEW
// import { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import BigSidebar from "../../../components/common/BigSidebar";
// import { BackIcon, NextIcon, PasswordIcon, ShowPasswordIcon } from "../../../components/common/IconComponents";
// import { Formik, Form } from 'formik';
// import * as Yup from 'yup';
// import FormikControl from '../../../components/signUpForm/ReusableFormik/FormikControl';

// const ChangePassword = () => {
//     const [showPassword, setShowPassword] = useState(false);
//     const [passwordIcon, setPasswordIcon] = useState(<PasswordIcon />);

//     const navigate = useNavigate();
//     const userRole = ''; // Replace with the actual user role value from authentication

//     const toggleShowPassword = () => {
//         setShowPassword(!showPassword);
//         setPasswordIcon(showPassword ? <PasswordIcon /> : <ShowPasswordIcon className="w-4" />);
//     };

//     const adminListItems = [
//         { label: 'Company Profile' },
//         { label: 'My Profile' },
//         { label: 'Password' },
//         { label: 'Notification' },
//         { label: 'Maintain Roles' },
//     ];

//     const analystListItems = [
//         { label: 'My Profile' },
//         { label: 'Password' },
//         { label: 'Notification' },
//     ];

//     const listItems = userRole === 'admin' ? adminListItems : analystListItems;

//     const initialValues = {
//         currentPassword: '',
//         newPassword: '',
//         confirmPassword: '',
//     };

//     const validationSchema = Yup.object({
//         currentPassword: Yup.string()
//             .required('Password is required')
//             .min(8, 'Password must be at least 8 characters long')
//             .matches(
//                 /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
//                 'Password must contain at least one digit, one lowercase letter, one uppercase letter, and one special character'
//             ),
//         newPassword: Yup.string()
//             .required('Password is required')
//             .min(8, 'Password must be at least 8 characters long')
//             .matches(
//                 /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
//                 'Password must contain at least one digit, one lowercase letter, one uppercase letter, and one special character'
//             ),
//         confirmPassword: Yup.string()
//             .oneOf([Yup.ref('newPassword'), ''], 'Passwords must match')
//             .required('Required'),
//     });

//     // Form submission
//     const onSubmit = (values) => {
//         console.log('Form data', values);
//         navigate("/resetNotification");
//     };

//     const goBack = () => {
//         window.history.back();
//     };

//     return (
//         <div className="relative flex flex-col md:flex-row px-3">
//             <BigSidebar />

//             <div className="md:w-2/5 md:ps-2 md:border-r-2 border-th-bg">
//                 <nav className="w-full md:w-[451px] fixed z-20 top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Settings</h1>
//                 </nav>

//                 <div className="mt-4 md:mt-24 mb-4">
//                     <ul>
//                         {listItems.map((item, index) => (
//                             <li
//                                 key={index}
//                                 className={`flex items-center justify-between cursor-pointer text-xs md:text-base font-normal mb-4 p-2 md:p-3 rounded ${index === 2
//                                     ? 'bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none'
//                                     : 'bg-white text-disabled'
//                                     }`}
//                             >
//                                 {item.label}
//                                 {index === 2 && <NextIcon className="ml-2" />}
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             <div className="w-auto md:w-3/5 md:px-2">
//                 <div className="">
//                     <nav className="flex items-center gap-4 md:w-[662px] sticky md:fixed z-20 top-16 md:top-0 bg-white">
//                         <BackIcon className="mt-4 py-2" onClick={goBack} />
//                         <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Change password</h1>
//                     </nav>

//                     <div className="mt-4 md:mt-24 mb-4">
//                         <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
//                             {(formik) => {
//                                 return (
//                                     <Form className="">
//                                         <div className="relative">
//                                             <FormikControl
//                                                 control="input"
//                                                 label="Current Password"
//                                                 type={showPassword ? 'text' : 'password'}
//                                                 placeholder="********"
//                                                 name="currentPassword"
//                                             />
//                                             <span
//                                                 onClick={toggleShowPassword}
//                                                 className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
//                                             >
//                                                 {passwordIcon}
//                                             </span>
//                                         </div>

//                                         <div className="relative">
//                                             <FormikControl
//                                                 control="input"
//                                                 label="Create new password"
//                                                 type={showPassword ? 'text' : 'password'}
//                                                 placeholder="********"
//                                                 name="newPassword"
//                                             />
//                                             <span
//                                                 onClick={toggleShowPassword}
//                                                 className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
//                                             >
//                                                 {passwordIcon}
//                                             </span>
//                                         </div>

//                                         <div className="relative">
//                                             <FormikControl
//                                                 control="input"
//                                                 label="Re-enter password"
//                                                 type={showPassword ? 'text' : 'password'}
//                                                 placeholder="********"
//                                                 name="confirmPassword"
//                                             />
//                                             <span
//                                                 onClick={toggleShowPassword}
//                                                 className="absolute right-0 top-5 md:top-6 flex items-center pr-3 cursor-pointer"
//                                             >
//                                                 {passwordIcon}
//                                             </span>
//                                         </div>

//                                         <button
//                                             type="submit"
//                                             className="bg-indigo-500 text-slate-50 border rounded cursor-pointer my-7 py-1 px-16"
//                                             disabled={!formik.isValid}
//                                         >
//                                             Save
//                                         </button>
//                                     </Form>
//                                 );
//                             }}
//                         </Formik>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ChangePassword;



// fall back - recent
// import { NextIcon } from "../../../components/common/IconComponents";
// import ChangePassword from "./ChangePassword";

// const ChangePasswordNavigation = () => {
//     const listItems = [
//         { label: 'Company Profile' },
//         { label: 'My Profile' },
//         { label: 'Password' },
//         { label: 'Notification' },
//         { label: 'Maintain Roles' },
//     ];

//     return (
//         <div className="relative flex flex-col md:flex-row px-3">
//             <div className="md:w-2/5 md:ps-2 md:border-r-2 border-th-bg">
//                 <nav className="w-full md:w-[451px] fixed z-20 top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Settings</h1>
//                 </nav>

//                 <div className="mt-4 md:mt-24 mb-4">
//                     <ul>
//                         {listItems.map((item, index) => (
//                             <li
//                                 key={index}
//                                 className={`flex items-center justify-between cursor-pointer text-xs md:text-base font-normal mb-4 p-2 md:p-3 rounded ${index === 2
//                                     ? 'bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none'
//                                     : 'bg-white text-disabled'
//                                     }`}
//                             >
//                                 {item.label}
//                                 {index === 2 && <NextIcon className="ml-2" />}
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             <div className="w-auto md:w-3/5 md:px-2">
//                 <ChangePassword />
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;





// import React, { useState } from "react";
// import ChangePassword from "./ChangePassword";
// import TabbedNavigation from "./PasswordTabNavigation";

// const ChangePasswordNavigation = () => {
//     const [activeTab, setActiveTab] = useState(1);

//     const tabs = [
//         {
//             id: 1,
//             label: "Change Password",
//             extraText: "Update your password",
//             path: "/change-password"
//         },
//     ];

//     const activeTabContent = tabs.find(tab => tab.id === activeTab);

//     return (
//         <div className="flex">
//             <div className="w-2/5">
//                 <TabbedNavigation tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
//             </div>

//             <div className="w-auto md:w-3/5 md:px-2">
//                 {activeTabContent && activeTabContent.id === 1 && <ChangePassword />}
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;



// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";
// import { useNavigate } from 'react-router-dom';
// import ChangePassword from "./ChangePassword";

// const ChangePasswordNavigation = () => {
//     const [activeTab, setActiveTab] = useState(1);
//     const navigate = useNavigate();

//     const navigateToPage = () => {
//         navigate("/change-password");
//     };

//     return (
//         <div className="flex">
//             <div className="w-2/5">
//                 <ul className="mt-4 md:mt-24 mb-4">
//                     <li
//                         className={`flex items-center justify-between cursor-pointer text-sm md:text-base font-normal mb-4 py-2 px-2 md:px-4 rounded ${activeTab === 1 ? "bg-th-bg text-activesettings-text" : "bg-white text-disabled"
//                             }`}
//                         onClick={navigateToPage}
//                     >
//                         <div>
//                             <span>Change Password</span>
//                             <p className="text-xs md:text-sm text-gray-500">Update your password</p>
//                         </div>
//                         <NextIcon
//                             className={`ml-2ta ${activeTab === 1 ? "text-activesettings-text" : "text-disabled"
//                                 }`}
//                             onClick={navigateToPage}
//                         />
//                     </li>
//                 </ul>
//             </div>
//             <div className="w-auto md:w-3/5 md:px-2">
//                 {activeTab === 1 && <ChangePassword />}
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;
















// not navigated to change password
// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";
// import { useNavigate } from 'react-router-dom';

// const ChangePasswordNavigation = ({ tab }) => {
//     const [activeTab, setActiveTab] = useState(tab.id);
//     const navigate = useNavigate();

//     const navigateToPage = (path) => {
//         navigate(path);
//     };

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     return (
//         <div className="">
//             <div className="">
//                 <ul className="mt-4 md:mt-24 mb-4">
//                     <li
//                         key={tab.id}
//                         className={`flex items-center justify-between cursor-pointer text-sm md:text-base font-normal mb-4 py-2 px-2 md:px-4 rounded ${activeTab === tab.id ? "bg-th-bg text-activesettings-text" : "bg-white text-disabled"
//                             }`}
//                         onClick={() => navigateToPage(tab.path)}
//                     >
//                         <div>
//                             <span>{tab.label}</span>
//                             <p className="text-xs md:text-sm text-gray-500">{tab.extraText}</p>
//                         </div>
//                         <NextIcon
//                             className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
//                                 }`}
//                         />
//                     </li>
//                 </ul>
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;


// copied from tabbed navigation. tabs
// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";
// import { useNavigate } from 'react-router-dom';

// const ChangePasswordNavigation = ({ tabs }) => {
//     const [activeTab, setActiveTab] = useState(tabs[0].id);
//     const navigate = useNavigate();

//     const navigateToPage = (path) => {
//         navigate(path);
//     };

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     return (
//         <div className="">
//             <div className="">
//                 <ul className="mt-4 md:mt-24 mb-4">
//                     {tabs.map((tab) => (
//                         <li
//                             key={tab.id}
//                             className={`flex items-center justify-between cursor-pointer text-sm md:text-base font-normal mb-4 py-2 px-2 md:px-4 rounded ${activeTab === tab.id ? "bg-th-bg text-activesettings-text" : "bg-white text-disabled"
//                                 }`}
//                             onClick={() => navigateToPage(tab.path)}
//                         >
//                             <div>
//                                 <span>{tab.label}</span>
//                                 <p className="text-xs md:text-sm text-gray-500">{tab.extraText}</p>
//                             </div>
//                             <NextIcon
//                                 className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
//                                     }`}
//                             />
//                         </li>
//                     ))}
//                 </ul>
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;






//fall back
// import React from 'react';
// import ChangePassword from './ChangePassword';

// const ChangePasswordNavigation = ({ tabs, activeTab, handleTabClick }) => {
//     return (
//         <div>
//             <nav>
//                 <ul>
//                     {tabs.map((item) => (
//                         <li
//                             key={item.id}
//                             className={`px-3 cursor-pointer ${item.id === activeTab ? 'border-b-2 border-[#51aad8] font-medium text-[#51aad8]' : 'text-[#a6a6a6]'}`}
//                             onClick={() => handleTabClick(item.id)}
//                         >
//                             {item.label}
//                         </li>
//                     ))}
//                 </ul>
//             </nav>
//             <div>
//                 {tabs.map((item) =>
//                     item.id === activeTab ? (
//                         <div key={item.id}>
//                             {item.id === 'Change Password' && <ChangePassword />}
//                         </div>
//                     ) : null
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;














// import React, { useState } from 'react';
// import ChangePassword from './ChangePassword';

// const ChangePasswordNavigation = ({ tab }) => {
//     const [activeTab, setActiveTab] = useState('');

//     const handleTabClick = (id) => {
//         setActiveTab(id);
//     };

//     return (
//         <div className="">
//             <nav className="">
//                 <ul className="flex items-center bg-white py-2">
//                     {tab.map((item) => (
//                         <li
//                             key={item.id}
//                             className={`px-3 cursor-pointer ${item.id === activeTab ? 'border-b-2 border-[#51aad8] font-medium text-[#51aad8]' : 'text-[#a6a6a6]'
//                                 }`}
//                             onClick={() => handleTabClick(item.id)}
//                         >
//                             {item.label}
//                         </li>
//                     ))}
//                 </ul>
//             </nav>
//             <div className="">
//                 {tab.map((item) =>
//                     item.id === activeTab ? (
//                         <div key={item.id} className="">
//                             {item.content}
//                         </div>
//                     ) : null
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;


// import React, { useState } from "react";
// import { NextIcon } from "../../../components/common/IconComponents";

// const ChangePasswordNavigation = ({ tab }) => {
//     const [activeTab, setActiveTab] = useState(tab[0].id);

//     const handleTabClick = (tabId) => {
//         setActiveTab(tabId);
//     };

//     const renderTabContent = () => {
//         const activeTabObj = tab.find((tab) => tab.id === activeTab);
//         if (activeTabObj) {
//             return activeTabObj.content;
//         }
//         return null;
//     };

//     return (
//         <div className="relative flex flex-col md:flex-row">
//             <div className="md:w-2/5 md:ps-2 md:border-r-2 border-th-bg">
//                 <nav className="w-full md:w-[451px] fixed z-20 top-0 bg-white">
//                     <h1 className="mt-4 py-2 text-lg md:text-[28px] font-medium">Settings</h1>
//                 </nav>

//                 <div className="mt-24">
//                     <ul>
//                         {tab.map((tab) => (
//                             <li
//                                 key={tab.id}
//                                 className={`flex items-center justify-between cursor-pointer text-xs md:text-base font-normal mb-4 p-2 md:p-3 rounded ${activeTab === tab.id
//                                     ? "bg-th-bg text-activesettings-text border-r-2 border-enabled-btn rounded-none"
//                                     : "bg-white text-disabled"
//                                     }`}
//                                 onClick={() => handleTabClick(tab.id)}
//                             >
//                                 {tab.label}
//                                 <NextIcon
//                                     className={`ml-2ta ${activeTab === tab.id ? "text-activesettings-text" : "text-disabled"
//                                         }`}
//                                 />
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             <div className="w-auto md:w-3/5 md:px-2">
//                 {renderTabContent()}
//             </div>
//         </div>
//     );
// };

// export default ChangePasswordNavigation;